import { Badge, SquarePenIcon } from '@buffer-mono/popcorn'
import type { BadgeProps } from '@buffer-mono/popcorn'

import styles from './PostStatusBadge.module.css'

import type { JSX } from 'react'

export const DraftBadge = (props: Pick<BadgeProps, 'size'>): JSX.Element => {
  return (
    <Badge className={styles.draft} size="medium" {...props}>
      <SquarePenIcon />
      Draft
    </Badge>
  )
}
